import React, { ReactNode } from 'react';

import HelpBox from '../HelpBox';

import { useDismissable } from 'app/developer-v3/hooks';

type Props = {
  description: ReactNode;
  heading: ReactNode | string;
  image?: ReactNode;
  persistId: string;
};

/**
 * Renders a HelpBox that can be dismissed. It can optionally take a `persistId`
 * that will save the id to localStorage upon dismissal. `persistId` should be namespaced
 * by a plugin name.
 */
function DismissableHelpBox(props: Props) {
  const { description, heading, image, persistId } = props;

  const { dismiss, isVisible } = useDismissable({ persistId });

  return isVisible ? (
    <HelpBox
      description={description}
      heading={heading}
      image={image}
      onDismiss={dismiss}
    />
  ) : null;
}

export default DismissableHelpBox;
